// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"84":"42c2d908","256":"7a1170f7","511":"fd7848dc","727":"fbb4d518"}[chunkId] + ".css";
};